import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import jwtDecode from 'jwt-decode';
import { Formik, FormikProps } from "formik";
import { Alert, Button, Form } from "react-bootstrap";
import { useLoginMutation } from "../../redux/slices/authApiSlice";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../redux/slices/authSlice";
import LoadingAlert from "../LoadingAlert";
import MicrosoftLogo from '../../assets/img/brands/microsoft.svg';
import getAzureOAuthURL from "../../utils/getAzureUrl";
import ErrorAlert from "../ErrorAlert";
import { Loader } from "react-feather";
import useAuth from "../../hooks/useAuth";

function SignIn() {

  const azureURL = getAzureOAuthURL()

  let content = (
    <>
      <hr />
      <div className="text-center mt-3">
        <Button
          onClick={() => getAzureOAuthURL()}
          href={azureURL}
          variant="microsoft"
          size="lg"
        >
          <img src={MicrosoftLogo} /> {" "}
          <p className="text-white" style={{ fontSize: 14 }}> Sign In with Microsoft</p>
        </Button>
      </div>
    </>
  )

  return content

}

export default SignIn;
